import React from "react";
import { useTranslation } from "react-i18next";
import RatingList from "./RatingList";
import Success from "../../assets/images/success.svg";
import "../../assets/css/rating-template.css";
import { appConstants } from "../../utils/constants";
import { conceptMap } from "../../utils/concept-enum";
import { useDashboardContext } from "../../context/customhook/dashboardHook";

export default function RatingsWrapper() {
  const { t } = useTranslation();
  const { dashboardStates } = useDashboardContext();

  function getConceptName() {
    let concept = parseInt(localStorage.getItem(appConstants.conceptCode), 10);
    return conceptMap.get(concept);
  }

  return (
    <div>
      <div
        className={
          dashboardStates.rating !== null
            ? "container-after-rating"
            : "rating-background"
        }
      >
        <div className="success-container">
          {dashboardStates.rating !== null ? (
            <>
              <img src={Success} alt="logo" className="success-img" />
              <label className="recommendation">
                {t(appConstants.thankyou)}
              </label>
            </>
          ) : (
            <>
              <label className="help-us">{t("helpUs")}</label>
              <label className="recommendation">{t(getConceptName())} </label>
            </>
          )}
        </div>
        <RatingList />
        <div className="likely-space-between">
          <label className="not-likely">{t(appConstants.likely)}</label>
          <label className="likely">{t(appConstants.extremelyLikely)}</label>
        </div>
      </div>
    </div>
  );
}
